import services from '../services'
import * as types from './mutation-types'

export const getPositus = ({ commit }, params) => (
  services.getPositus(params).then(res => {
    return res.data
  })
)

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_TEMPLATES, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_TEMPLATE, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveTemplate(obj).then(res => {
    commit(types.SET_TEMPLATE, res.data.data)
    return res
  })
}

export const deleteTemplate = async ({ commit }, obj) => {
  await services.deleteTemplate(obj).then(res => {
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}
